<div mat-dialog-content>
  <img [src]="data.imageUrl" alt="Full Size Image" class="full-size-image" />
</div>
